import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './components/dialog/dialog.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { DialogButtonsContainerComponent } from './components/dialog-buttons-container/dialog-buttons-container.component';
import { DialogButtonComponent } from './components/dialog-button/dialog-button.component';
import { DialogDescriptionComponent } from './components/dialog-description/dialog-description.component';
import { DialogTitleComponent } from './components/dialog-title/dialog-title.component';
import { ButtonLegacyModule } from 'studio-components/button-legacy/button-legacy.module';

const components = [
  DialogComponent,
  DialogTitleComponent,
  DialogDescriptionComponent,
  DialogButtonComponent,
  DialogButtonsContainerComponent,
];

@NgModule({
  declarations: components,
  imports: [CommonModule, MatDialogModule, ButtonLegacyModule],
  exports: components,
})
export class DialogModule {}
